import React from "react";

let cancelToken;
const getCSVReport = (response, filename) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const downloadLink = document.createElement("a");
  downloadLink.href = url;

  downloadLink.download = filename + ".csv";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export default getCSVReport;
